export default "__VITE_ASSET__DaXb6sq6__"